var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconScaleData = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 27,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M30 0H2C.9 0 0 .9 0 2v28c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM16 4.4l4.6 4.5h-2.9v4h-3.1v-4h-3L16 4.4zM4.4 16 9 11.5v3h4v3.1H9v2.9L4.4 16zM16 27.6 11.5 23h2.9v-4h3.1v4h3L16 27.6zm7.1-7.1v-3h-4v-3.1h4v-2.9l4.5 4.6-4.5 4.4z"
})));
export default SvgIconScaleData;